export namespace CurrencyHelper {
  export const formatIndianNumber = (value: number): string => {
    if (!Number.isFinite(value)) return "-";

    const truncate2 = (num: number) => Math.floor(num * 100) / 100;

    if (value >= 1e7) {
      return (
        truncate2(value / 1e7)
          .toFixed(2)
          .replace(/\.00$/, "") + "Cr"
      );
    } else if (value >= 1e5) {
      return (
        truncate2(value / 1e5)
          .toFixed(2)
          .replace(/\.00$/, "") + "L"
      );
    } else if (value >= 1e3) {
      return (
        truncate2(value / 1e3)
          .toFixed(2)
          .replace(/\.00$/, "") + "K"
      );
    }
    return value.toString();
  };
}
